module.exports = __webpack_public_path__ + "img/horizontal.f9b1dee5.svg";